import { render, staticRenderFns } from "./ProgresoRegistro.vue?vue&type=template&id=31c30b8c&"
import script from "./ProgresoRegistro.vue?vue&type=script&lang=js&"
export * from "./ProgresoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./ProgresoRegistro.vue?vue&type=style&index=0&id=31c30b8c&prod&lang=css&"
import style1 from "./ProgresoRegistro.vue?vue&type=style&index=1&id=31c30b8c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports